$("#tabla_usuarios").DataTable({
    dom: '<"d-flex justify-content-between"lB><"col-md-6 p-0 my-3 float-end"f>rtip',
    buttons: [
        'excel', 'pdf'
    ],
    language: {
        url: url_base+'/vendor/datatables/spanish.json'
    },
});

eliminarUsuario = function(e){
    var data = e.dataset;
    $("#form_eliminar_usuario")[0].reset();
    $("#eliminar_usuario_id").val(data.id);
    $("#eliminar_usuario_nombre").html(`¿Deseas eliminar el usuario <strong>${data.nombre}</strong>?`);
}
